module.exports = __webpack_public_path__ + "static/media/login-cobranza.0dc6df49.jpg";